<!--
Panel Component — wraps PrimeVue Panel for collapsible/titled content sections.

Use for grouping content under a header (collapsible config sections,
expandable details). For plain card-style containers without a header
or collapse, prefer <box>. For form-like grouped fields prefer
<fieldset-panel>.
-->

<template>
  <PrimePanel v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </PrimePanel>
</template>

<script setup lang="ts">
import PrimePanel from 'primevue/panel';

defineOptions({ name: 'Panel', inheritAttrs: false });
</script>
